<h4>{{ title }}</h4>
<soft-check-group
  class="flex flex-col justify-center"
  [checkStrategy]="strategy"
  [value]="values"
  #checkGrp="softCheckGroup"
  >
  @for (option of options; track option; let i = $index) {
    <soft-checkbox
      class="mt-2"
      [trueValue]="option.value"
      [falseValue]="undefined"
      >
      <span class="soft-label right">{{ option.title }}</span>
    </soft-checkbox>
  }
</soft-check-group>
<div class="flex flex-row justify-end">
  <button class="soft-button primary" (click)="onSubmit(checkGrp.value)">
    {{ '#DYNAMIC.MULTI_SELECT.SUBMIT' | translate }}
  </button>
</div>
